import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_PAYMENT_METHODS: string = '[ecommerce payment methods] Load Ecommerce Payment Methods';
export const LOAD_ECOMMERCE_PAYMENT_METHODS_SUCCESS: string = '[ecommerce payment methods] Load Ecommerce Payment Methods Success';
export const LOAD_ECOMMERCE_PAYMENT_METHODS_FAIL: string = '[ecommerce payment methods] Load Ecommerce Payment Methods Fail';

export class LoadEcommercePaymentMethods implements Action {
  readonly type: string = LOAD_ECOMMERCE_PAYMENT_METHODS;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommercePaymentMethodsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PAYMENT_METHODS_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommercePaymentMethodsFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_PAYMENT_METHODS_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommercePaymentMethodsAction = LoadEcommercePaymentMethods | LoadEcommercePaymentMethodsSuccess | LoadEcommercePaymentMethodsFail;
